var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dialog-form" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "修改商品监控规则",
            visible: _vm.dialogVisible,
            "close-on-click-modal": false,
            "destroy-on-close": "",
            width: "1000px",
            "custom-class": "custom-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.resetForm,
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", disabled: _vm.formLoading },
                      on: { click: _vm.submitForm },
                    },
                    [_vm._v("保 存")]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.dialogVisible = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "div",
            [
              _vm.formType != "update"
                ? _c("div", { staticClass: "step-title" }, [
                    _vm._v("设置商品监控规则"),
                  ])
                : _vm._e(),
              _vm.formType != "create" && _vm.rulesForm.productImage
                ? _c(
                    "div",
                    { staticClass: "ml40 mb20 goods-info" },
                    [
                      _c("el-image", {
                        staticClass: "goods-img",
                        attrs: {
                          src: _vm.rulesForm.productImage,
                          "preview-src-list": [_vm.rulesForm.productImage],
                        },
                      }),
                      _c("div", { staticClass: "info-content ml20" }, [
                        _c("div", { staticClass: "info-title" }, [
                          _vm._v(" ("),
                          _c("span", { staticClass: "text-highlight" }, [
                            _vm._v(_vm._s(_vm.rulesForm.productId)),
                          ]),
                          _vm._v(
                            ") " + _vm._s(_vm.rulesForm.productName) + " "
                          ),
                        ]),
                        _c("div", { staticClass: "info-text mt15" }, [
                          _vm._v(_vm._s(_vm.rulesForm.specName)),
                        ]),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form",
                {
                  ref: "formRef",
                  attrs: {
                    model: _vm.rulesForm,
                    rules: _vm.rules,
                    "label-width": "160px",
                  },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "监控频率：",
                                prop: "monitorRateId",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { placeholder: "请选择监控频率" },
                                  model: {
                                    value: _vm.rulesForm.monitorRateId,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.rulesForm,
                                        "monitorRateId",
                                        $$v
                                      )
                                    },
                                    expression: "rulesForm.monitorRateId",
                                  },
                                },
                                _vm._l(
                                  _vm.monitorRateIdOptions,
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("span", { staticClass: "tips-text" }, [
                          _vm._v(
                            "设置系统检查价格变动的频率，高频监控可能影响系统性能"
                          ),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "对比平台：", prop: "platformIds" } },
                    [
                      _c(
                        "el-checkbox-group",
                        {
                          model: {
                            value: _vm.rulesForm.platformIds,
                            callback: function ($$v) {
                              _vm.$set(_vm.rulesForm, "platformIds", $$v)
                            },
                            expression: "rulesForm.platformIds",
                          },
                        },
                        _vm._l(_vm.platformIdsOptions, function (item, index) {
                          return _c(
                            "el-checkbox",
                            { key: index, attrs: { label: item.value } },
                            [_vm._v(_vm._s(item.label))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c("el-form-item", [
                    _c(
                      "span",
                      {
                        staticClass: "tips-label",
                        attrs: { slot: "label" },
                        slot: "label",
                      },
                      [_vm._v("设置预警阈值：")]
                    ),
                    _c("span", { staticClass: "tips-text" }, [
                      _vm._v(
                        "上涨预警阈值比例、下降预警阈值比例、上涨预警阈值、下降预警阈值四个值至少填1个，监控的商品只要一个涨跌超过阈值就预警。"
                      ),
                    ]),
                  ]),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "上涨预警阈值(比例)：",
                                prop: "raiseWarnRatio",
                              },
                            },
                            [
                              _c(
                                "el-input",
                                {
                                  attrs: {
                                    placeholder: "请输入",
                                    oninput:
                                      "value=value.replace(/[^\\d\\.]/g,'')",
                                  },
                                  model: {
                                    value: _vm.rulesForm.raiseWarnRatio,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.rulesForm,
                                        "raiseWarnRatio",
                                        $$v
                                      )
                                    },
                                    expression: "rulesForm.raiseWarnRatio",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      attrs: { slot: "suffix" },
                                      slot: "suffix",
                                    },
                                    [_vm._v("%")]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "下降预警阈值(比例)：",
                                prop: "decreaseWarnRatio",
                              },
                            },
                            [
                              _c(
                                "el-input",
                                {
                                  attrs: {
                                    placeholder: "请输入",
                                    oninput:
                                      "value=value.replace(/[^\\d\\.]/g,'')",
                                  },
                                  model: {
                                    value: _vm.rulesForm.decreaseWarnRatio,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.rulesForm,
                                        "decreaseWarnRatio",
                                        $$v
                                      )
                                    },
                                    expression: "rulesForm.decreaseWarnRatio",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      attrs: { slot: "suffix" },
                                      slot: "suffix",
                                    },
                                    [_vm._v("%")]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "上涨预警阈值(固定值)：",
                                prop: "raiseWarnFix",
                              },
                            },
                            [
                              _c(
                                "el-input",
                                {
                                  attrs: {
                                    placeholder: "请输入",
                                    oninput:
                                      "value=value.replace(/[^\\d\\.]/g,'')",
                                  },
                                  model: {
                                    value: _vm.rulesForm.raiseWarnFix,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.rulesForm,
                                        "raiseWarnFix",
                                        $$v
                                      )
                                    },
                                    expression: "rulesForm.raiseWarnFix",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      attrs: { slot: "suffix" },
                                      slot: "suffix",
                                    },
                                    [_vm._v("元")]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "下降预警阈值(固定值)：",
                                prop: "decreaseWarnFix",
                              },
                            },
                            [
                              _c(
                                "el-input",
                                {
                                  attrs: {
                                    placeholder: "请输入",
                                    oninput:
                                      "value=value.replace(/[^\\d\\.]/g,'')",
                                  },
                                  model: {
                                    value: _vm.rulesForm.decreaseWarnFix,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.rulesForm,
                                        "decreaseWarnFix",
                                        $$v
                                      )
                                    },
                                    expression: "rulesForm.decreaseWarnFix",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      attrs: { slot: "suffix" },
                                      slot: "suffix",
                                    },
                                    [_vm._v("元")]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "特殊监控规则：",
                                prop: "specialRuleIds",
                              },
                            },
                            [
                              _c(
                                "el-checkbox-group",
                                {
                                  model: {
                                    value: _vm.rulesForm.specialRuleIds,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.rulesForm,
                                        "specialRuleIds",
                                        $$v
                                      )
                                    },
                                    expression: "rulesForm.specialRuleIds",
                                  },
                                },
                                _vm._l(
                                  _vm.specialRuleIdsOptions,
                                  function (item, index) {
                                    return _c(
                                      "el-checkbox",
                                      {
                                        key: index,
                                        attrs: { label: item.value },
                                      },
                                      [_vm._v(_vm._s(item.label))]
                                    )
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }